module.exports = {
  MenuManagement: 'Quản lý menu',
  CustomerMenu: 'Menu khách hàng',
  CustomerAutomation: 'Tự động hóa khách hàng',
  Search: 'Tìm kiếm',
  PleaseEnterChinese: 'Vui lòng nhập tiếng Trung, tiếng Anh hoặc mã',
  AddMenu: 'Thêm menu mới',
  UpdateMenu: 'Sửa đổi menu',
  AddCustomerMenu: 'Thêm menu khách hàng mới',
  Refresh: 'Làm mới',
  ChineseName: 'Tên tiếng Trung',
  EnglishName: 'Tên tiếng Anh',
  Coding: 'Mã hóa',
  Icon: 'Biểu tượng',
  Node: 'Nút',
  ParentNode: 'Nút cha',
  Order: 'Thứ tự',
  ModuleFile: 'Tệp mô-đun',
  H5Url: 'Địa chỉ H5',
  Type: 'Loại',
  Module: 'Mô-đun',
  Component: 'Thành phần',
  Add: 'Thêm mới',
  Update: 'Sửa đổi',
  Save: 'Lưu',
  Cancel: 'Hủy',
  OK: 'Xác nhận',
  ChineseCanNotBeEmpty: 'Tiếng Trung không được để trống',
  EnglishCanNotBeEmpty: 'Tiếng Anh không được để trống',
  TheEncodingCanNotBeEmpty: 'Mã hóa không được để trống',
  SavedSuccess: 'Lưu thành công',
  PleaseSelectTheMenu: 'Vui lòng chọn menu',
  PleaseSelectTheCustomer: 'Vui lòng chọn khách hàng',
  NoCustomersWantToAdd: 'Không có khách hàng nào cần thêm',
  Prompt: 'Nhắc nhở',
  Removed: 'Loại bỏ',
  Numbering: 'Số hiệu',
  delete: 'Xóa',
  CompanyChineseName: 'Tên tiếng Trung',
  SuccessfullyDeleted: 'Xóa thành công',
  DeleteData: 'Vui lòng chọn khách hàng cần xóa',
  UpdateData: 'Vui lòng chọn thông tin khách hàng cần sửa đổi',
  InitData: 'Vui lòng chọn khách hàng cần xem dữ liệu cơ bản khởi tạo',
  SearchTitle: 'Vui lòng nhập tên công ty hoặc mã công ty để tra cứu',
  BasicData: 'Dữ liệu cơ bản',
  ExpiredCustomerNotification: 'Thông báo hết hạn khách hàng',
  CompanyName: 'Tên công ty',
  CompanyCode: 'Mã công ty',
  CompanyPhone: 'Điện thoại công ty',
  CompanyEMail: 'Email công ty',
  CompanyFax: 'Fax công ty',
  CreateDate: 'Thời gian tạo',
  GroupCompany: 'Tập đoàn công ty',
  InitializeCustomer: 'Công ty đăng ký',
  copy: 'Vui lòng chọn môi trường cần sao chép',
  InitializeData: 'Khởi tạo dữ liệu cơ bản',
  InitializeMenu: 'Khởi tạo menu',
  CompanyNamePrompt: 'Tên công ty là bắt buộc',
  mailbox: 'Email quản trị viên là bắt buộc',
  UpdateSuccess: 'Sửa thông tin thành công',
  Initialized: 'Khởi tạo thành công',
  CompanyAddress: 'Địa chỉ công ty',
  AdminChineseName: 'Tên tiếng Trung của quản trị viên',
  AdminEnglishName: 'Tên tiếng Anh của quản trị viên',
  email: 'Email quản trị viên',
  phone: 'Số điện thoại quản trị viên',
  Current: 'Mã công ty',
  StandardLibrary: 'Môi trường tiêu chuẩn',
  Next: 'Bước tiếp theo',
  Back: 'Bước trước',
  Finish: 'Hoàn thành',
  Initialize: 'Khởi tạo',
  Harbour: 'Cảng biển',
  Airport: 'Cảng hàng không',
  ChargesItems: 'Hạng mục thu phí',
  AirRoute: 'Tuyến đường',
  NetWork: 'Mạng lưới',
  Currency: 'Loại tiền tệ',
  EQType: 'Loại container',
  Packing: 'Bao bì',
  HouseBlType: 'Loại vận đơn',
  CargoType: 'Loại hàng hóa',
  IncoTerm: 'Điều khoản thương mại',
  ShippingTerm: 'Điều khoản vận chuyển',
  TradeTerm: 'Phương thức thương mại',
  CustomerType: 'Loại khách hàng',
  PortGroup: 'Cảng liên quan',
  OtherChargeItem: 'Phụ phí vận đơn hàng không',
  ShippingCompaniesAirlines: 'Công ty tàu, hãng hàng không',
  Template: 'Mẫu',
  AirService: 'Hạng mục dịch vụ cước hàng không',
  BlMode: 'Phương thức vận đơn',
  CustomJobType: 'Loại nghiệp vụ tùy chỉnh',
  TransmitFileType: 'Loại tài liệu lưu chuyển',
  copyTenantId: 'Vui lòng chọn môi trường cần sao chép',
  imgToolTip: 'Điền thông tin công ty và quản trị viên hệ thống\nEmail quản trị viên là thông tin đăng nhập',
  imgToolTip2: 'Mẫu cần sao chép',
  imgToolTip3: 'Dữ liệu cơ bản nền tảng',
  imgToolTip4: 'Menu nền tảng',
  Sequence: 'Chuỗi',
  documentCategory: 'Quản lý loại tài liệu',
  charegeUnit: 'Đơn vị tính phí / Đơn vị',
  BusinessStatus: 'Quản lý trạng thái nghiệp vụ',
  PermissionConfig: 'Cấu hình quyền hạn',
  Report: 'Báo cáo',
  ConfigurationManagement: 'Quản lý cấu hình',
  SingleOnlineSet: 'Thiết lập đối chiếu trực tuyến',
  IsH5Open: 'H5 có mở không',
  CopySetting: 'Sao chép cấu hình',
  AllOpen: 'Mở tất cả',
  AllClose: 'Đóng tất cả',
  Start: 'Bắt đầu',
  StandardLibrary2: 'Thư viện tiêu chuẩn',
  OnlineCustomerService: 'Hỗ trợ trực tuyến',
  SubmitATicket: 'Gửi yêu cầu',
  CheckTheTicket: 'Xem yêu cầu',
  Menu1: 'Thực đơn',
  HelpCenter: 'Trung tâm trợ giúp',
  HelpVideo: 'Video hướng dẫn',
  SystemOperationGuidance: 'Hướng dẫn thao tác hệ thống',
  InitializeBoot: 'Hướng dẫn khởi tạo',
  SpareQQ: 'QQ dự phòng',
  SettingsAndTools: 'Thiết lập và công cụ',
  ReportStatistics: 'Thống kê báo cáo',
  Weibo: 'Weibo',
  LogInformation: 'Thông tin nhật ký',
  BillingSystem: 'Hệ thống tính phí',
  UnbindWeChat: 'Hủy liên kết WeChat',
  SystemInformation: 'Thông tin hệ thống',
  SignOut: 'Đăng xuất',
  WallTechFamily: 'WoHang Home',
  Notice: 'Nhắc nhở',
  ClearLog: 'Xóa nhật ký',
  UploadLog: 'Tải lên nhật ký',
  AuthorizationToken: 'Token ủy quyền:',
  LogLevel: 'Cấp độ nhật ký:',
  Source: 'Nguồn',
  AccountInformation: 'Thông tin tài khoản',
  ShowYourAccountNumberAndTheCompaniesAndDepartmentsToWhichYouBelongHere: 'Tại đây hiển thị tài khoản, công ty và phòng ban của bạn',
  InStationMessageReminder: 'Nhắc nhở tin nhắn nội bộ',
  WhenYouHaveAPendingTaskThereWillBeAToDoNumberOnTheBellToRemindYouToDealWithItInTime: 'Khi có nhiệm vụ chờ xử lý, chuông sẽ hiển thị số lượng để nhắc bạn',
  ClickHereToEnterWallTechFamilyToViewYourOrderTrainingVideosAndOtherInformation: 'Nhấn vào đây để vào WoLink Home xem đơn hàng, video đào tạo',
  WhenYouEncounterProblemsWithYourOperatingSystemYouCanContactOurOnlineCustomerServiceAtAnyTime: 'Khi gặp sự cố, hãy liên hệ hỗ trợ trực tuyến của chúng tôi',
  MultilingualSwitching: 'Chuyển đổi ngôn ngữ',
  SwitchDifferentLanguages: 'Thay đổi ngôn ngữ',
  HereIsAHelpfulCenterSystemRelatedConfigurationToolsReportStatisticsBillingSystemAndOtherMoreInformation: 'Tại đây có trung tâm trợ giúp, công cụ cấu hình, thống kê báo cáo, hệ thống tính phí',
  OperationArea: 'Khu vực làm việc',
  HereIsTheOperationInterfaceForYourDailyWork: 'Đây là giao diện thao tác công việc hàng ngày của bạn',
  MenuBar: 'Thanh menu',
  TheSystemModuleMenuBarDisplayedHereMatchesThePermissionsOfYourLoginAccount: 'Hiển thị menu hệ thống phù hợp với quyền hạn tài khoản của bạn',
  More: 'Thêm',
  Skip: 'Bỏ qua',
  WeChatUnbindingFailed: 'Hủy liên kết WeChat không thành công',
  WhetherToConfirmWeChatUnbinding: 'Bạn có chắc chắn muốn hủy liên kết WeChat không?',
  Unbind: 'Hủy bỏ hủy liên kết',
  WeChatUnbindingSuccessfully: 'Hủy liên kết WeChat thành công',
  DearYouHaventBoundYourWeChatAccountYet: 'Bạn chưa liên kết tài khoản WeChat',
  AdministratorInitializationOperationGuidance: 'Hướng dẫn thao tác khởi tạo cho quản trị viên',
  ImproveEnterpriseInformation: 'Hoàn thiện thông tin doanh nghiệp',
  PleaseImproveYourCompanyEnterpriseInformation: 'Vui lòng hoàn thiện thông tin doanh nghiệp của công ty bạn',
  CreateAUser: 'Tạo người dùng',
  CreateOurUsersAndSetPermissions: 'Tạo người dùng cho công ty và thiết lập quyền hạn',
  CustomerDataImport: 'Nhập dữ liệu khách hàng/đối tác',
  InitializeAndImportTheCompanyOriginalCustomerInformation: 'Nhập dữ liệu khách hàng/đối tác hiện có của công ty',
  ViewTheSteps: 'Xem các bước thao tác',
  YouAreNotAuthorizedToUseStatisticalAnalysisFunction: 'Bạn không được cấp quyền sử dụng chức năng thống kê phân tích'
}
